import { toAuthUrl } from "./authModal";

/**
 * Build and validate same-app intended and return URLs.
 * Query values are encoded by URLSearchParams so path, search, and hash survive redirects.
 */

export function currentPath(location) {
	if (!location?.pathname) {
		return "/";
	}

	return `${location.pathname}${location.search || ""}${location.hash || ""}`;
}

/**
 * Allow only same-app paths. Reject absolute, protocol-relative, and script URLs.
 * @param {string|null|undefined} raw
 * @param {string|null} fallback
 * @returns {string|null}
 */
export function resolveSafeInternalPath(raw, fallback = null) {
	if (raw == null) {
		return fallback;
	}

	let value = String(raw).trim();
	if (!value) {
		return fallback;
	}

	if (!value.startsWith("/") && value.includes("%")) {
		try {
			value = decodeURIComponent(value);
		} catch (error) {
			return fallback;
		}
	}

	if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) {
		return fallback;
	}

	if (value.includes("\\") || /[\u0000-\u001F\u007F]/.test(value)) {
		return fallback;
	}

	const lower = value.toLowerCase();
	if (lower.includes("://") || lower.includes("javascript:") || lower.includes("data:")) {
		return fallback;
	}

	return value;
}

export function toLoginUrl(location) {
	return toAuthUrl(location, "login");
}

export function toLoginSearch(location) {
	const params = new URLSearchParams({ auth: "login", intended: currentPath(location) });
	return `?${params.toString()}`;
}

export function withReturnUrl(path, { returnUrl, code } = {}) {
	const params = new URLSearchParams();
	const safeReturnUrl = resolveSafeInternalPath(returnUrl);

	if (safeReturnUrl) {
		params.set("returnUrl", safeReturnUrl);
	}

	if (code) {
		params.set("code", code);
	}

	const query = params.toString();
	return query ? `${path}?${query}` : path;
}
